import { Button } from "components/DesignSystem/Button/Button";
import { CopyIcon } from "components/icons/CopyIcon";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";

export const MaskedValue = ({
  value,
  isEncrypted = true,
  isCopyable = true,
}: {
  value: string | string[];
  isEncrypted?: boolean;
  isCopyable?: boolean;
}) => {
  const { copyToClipboard } = useCopyToClipboard();

  if (typeof value !== "string") {
    return "-";
  }

  const maskedVal =
    value && (typeof value === "string" || typeof value === "number")
      ? "*".repeat(value?.length)
      : null;
  const updatedValue = value ? value : "-";

  return (
    <div className="t-flex t-items-center">
      {isEncrypted ? (
        <span className="t-text-text-60 t-text-body-sm t-mt-1">
          {maskedVal}
        </span>
      ) : (
        updatedValue
      )}
      {isCopyable && (
        <Button
          type="button"
          size="xxsmall"
          customType="ghost_icon"
          onClick={() => copyToClipboard(value)}
        >
          <CopyIcon className="t-text-text-30" />
        </Button>
      )}
    </div>
  );
};
